import React from 'react';
export function SymptomsSection() {
  return <section className="bg-gradient-hero py-16 md:py-20 px-5 md:px-8" data-id="element-360" data-mp="3m583tb1wc66r">
      <div className="max-w-[1400px] mx-auto flex flex-col items-center text-center" data-id="element-361" data-mp="b4h3vznaczgi">
        <div className="text-center max-w-md mx-auto" data-id="element-362" data-mp="3sms7ev53j7lm">
          <h3 className="font-display text-[32px] leading-tight text-foreground" data-id="element-363" data-mp="3sk608wm4au3x">
            ¿Te reconocés en alguna de estas situaciones?
          </h3>

          <ul className="mt-8 space-y-4 text-left" data-id="element-364" data-mp="3jk93s8thkqyb">
            <li className="font-body text-foreground/80 rounded-[10px] px-4 py-3.5" style={{
            border: '0.5px solid rgba(200,168,112,0.16)',
            background: 'rgba(255,255,255,0.02)'
          }} data-id="element-365" data-mp="3nmxfqpdhydzi">
              <p className="text-[18px]" data-id="element-366" data-mp="3elz7tvzxtmbn">Dormís pero no descansás.</p>
              <p className="text-[14px] text-foreground/55 mt-1" data-id="element-367" data-mp="3eobs4ft648rv">
                Ocho horas y aun así necesitás café para funcionar.
              </p>
            </li>

            <li className="font-body text-foreground/80 rounded-[10px] px-4 py-3.5" style={{
            border: '0.5px solid rgba(200,168,112,0.16)',
            background: 'rgba(255,255,255,0.02)'
          }} data-id="element-368" data-mp="1ctjdl3gapk1s">
              <p className="text-[18px]" data-id="element-369" data-mp="2whi9eryj4vtr">
                Tu cintura cambió aunque comés parecido.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1" data-id="element-370" data-mp="3aazs6aje64iq">
                La ropa que antes te quedaba bien hoy no cierra igual.
              </p>
            </li>

            <li className="font-body text-foreground/80 rounded-[10px] px-4 py-3.5" style={{
            border: '0.5px solid rgba(200,168,112,0.16)',
            background: 'rgba(255,255,255,0.02)'
          }} data-id="element-371" data-mp="2iiitq9szvr9q">
              <p className="text-[18px]" data-id="element-372" data-mp="2rgkque9lxzrq">Ansiedad, antojos e hinchazón.</p>
              <p className="text-[14px] text-foreground/55 mt-1" data-id="element-373" data-mp="2mit2fu868vsa">
                Aparecen a la tarde, sin aviso, y cuesta pararlos.
              </p>
            </li>

            <li className="font-body text-foreground/80 rounded-[10px] px-4 py-3.5" style={{
            border: '0.5px solid rgba(200,168,112,0.16)',
            background: 'rgba(255,255,255,0.02)'
          }} data-id="element-374" data-mp="1tv7vvvm7lak">
              <p className="text-[18px]" data-id="element-375" data-mp="30jd7y8z78p29">
                Te exigís igual pero tu cuerpo ya no responde igual.
              </p>
              <p className="text-[14px] text-foreground/55 mt-1" data-id="element-376" data-mp="34mt12vc287a7">
                Ponés el mismo esfuerzo de siempre y los resultados ya no
                llegan.
              </p>
            </li>
          </ul>

          {/* Imagen — cierre emocional del espejo, no apertura */}
          <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ChatGPT_Image_9_jun_2026_02_48_17_p.m_430x.jpg?v=1781031076" alt="Mujer reflexionando" loading="lazy" decoding="async" className="w-full max-w-[430px] mx-auto rounded-xl mt-10" data-id="element-377" data-mp="2gx8jafrn7g2i" />

          {/* Closing card — cierra el espejo emocional y da paso al cambio de creencia */}
          

          <div className="mt-10" data-id="element-378" data-mp="1y5o3keclz26i">
            <p className="font-display text-[34px] leading-tight text-foreground" data-id="element-379" data-mp="1y4mq6384e3lm">
              No necesitás esforzarte más.
            </p>

            <p className="font-display italic text-[#C8A870] text-[30px] leading-tight mt-2" data-id="element-380" data-mp="1qk2bg5qisp3c">
              Necesitás entender qué cambió.
            </p>
            <div className="mt-8 mb-10 max-w-md mx-auto text-center" data-id="element-381" data-mp="1gmxo42kxunky"></div>
          </div>
        </div>
      </div>
    </section>;
}